import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss'],
})
export class ClientProfileComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  @Input() client_data: any;

  selected_tab: any = 'Existing Products';

  constructor() {}

  ngOnInit(): void {}
}
